import React from "react";
import { observer } from "mobx-react";
import copilotStore from "Stores/copilotStore";

// Compact chat card for the seller-profile draft (SG-2182). The real,
// editable review happens in SellerProfilePreviewPanel (right-side panel,
// same pattern as SequencePreviewPanel for sequence creation); this card
// just opens/reopens it.
const SellerProfilePreviewBlock = observer(({ block }) => {
  if (block.done) {
    const icon = block.discarded ? "delete_outline" : block.saved === false ? "error_outline" : "check_circle";
    const message = block.discarded
      ? "Seller profile discarded."
      : block.saved === false
        ? "Seller profile save failed."
        : "Seller profile saved.";
    return (
      <div className="copilotSellerProfile copilotSellerProfile--done">
        <i className="material-icons-outlined">{icon}</i>
        <span>{message}</span>
      </div>
    );
  }

  const building = block.status === "building";
  return (
    <div className={`copilotLiveCard status-${building ? "building" : "ready"}`} onClick={() => copilotStore.openPreviewPanel(block.id)}>
      <div className="copilotLiveCard__icon">
        {building ? <span className="copilotLiveCard__liveDot" /> : <i className="material-icons-outlined">storefront</i>}
      </div>
      <div className="copilotLiveCard__meta">
        <div className="copilotLiveCard__title">Seller profile draft</div>
        <div className="copilotLiveCard__sub">
          {building
            ? block.stage || "Researching…"
            : block.profile?.company_name
              ? `${block.profile.company_name} · ready for review`
              : "Ready for review"}
        </div>
      </div>
      <div className="copilotLiveCard__open">
        <span>{building ? "Watch live" : "Review & edit"}</span>
        <i className="material-icons-outlined">chevron_right</i>
      </div>
    </div>
  );
});

export default SellerProfilePreviewBlock;
